import React, { useState, useEffect } from 'react';
import './Collections.css';
import { motion } from 'framer-motion';

const collections = [
  {
    title: "Brown Checkered Shirt",
    brand: "Tag",
    price: "₹979.30",
    img: "https://blacksalt.ascentbw.com/Images/Category/New1.webp"
  },
  {
    title: "Aqua Printed Shirt",
    brand: "Tag",
    price: "₹1,119.30",
    img: "https://blacksalt.ascentbw.com/Images/Category/New2.webp"
  },
  {
    title: "White Checkered Shirt",
    brand: "Tag",
    price: "₹1,049.30",
    img: "https://blacksalt.ascentbw.com/Images/Category/New3.webp"
  },
  {
    title: "Black Printed Shirt",
    brand: "Tag",
    price: "₹1,049.30",
    img: "https://blacksalt.ascentbw.com/Images/Category/New4.webp"
  },
  {
    title: "Pink Checkered Shirt",
    brand: "Tag",
    price: "₹979.30",
    img: "https://blacksalt.ascentbw.com/Images/Category/New5.webp"
  },
  {
    title: "Dark Grey Printed Shirt",
    brand: "Tag",
    price: "₹1,119.30",
    img: "https://blacksalt.ascentbw.com/Images/Category/New6.webp"
  }
];

const Collections = () => {
  const [currentIndex, setCurrentIndex] = useState(0);
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 768);

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth <= 768);
    };
    window.addEventListener('resize', handleResize);
    
    const itemsToShow = isMobile ? 1 : 3;
    const timer = setInterval(() => {
      setCurrentIndex((prev) => (prev + 1) % (collections.length - (itemsToShow - 1)));
    }, 4000);

    return () => {
      clearInterval(timer);
      window.removeEventListener('resize', handleResize);
    };
  }, [isMobile]);

  return (
    <section className="collections" id="collections">
      <div className="collections-header">
        <motion.div 
          className="coll-label"
          initial={{ opacity: 0, x: -20 }}
          whileInView={{ opacity: 1, x: 0 }}
          viewport={{ once: true }}
        >
          COLLECTIONS
        </motion.div>
        <motion.h2 
          className="coll-title"
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
        >
          NEW ARRIVALS
        </motion.h2>
      </div>

      <div className="collections-slider-wrapper">
        <div 
          className="collections-grid" 
          style={{ 
            transform: `translateX(-${currentIndex * (isMobile ? 100 : 33.33)}%)`, 
            transition: 'transform 0.8s ease-in-out' 
          }}
        >
          {collections.map((item, index) => (
            <div key={index} className="coll-card">
              <div className="coll-info">
                <div className="coll-img">
                  <img src={item.img} alt={item.title} />
                </div>
                <div className="coll-info-bottom">
                  <h3>{item.title}</h3>
                  <p className="brand">{item.brand}</p>
                  <div className="price-row">
                    <span className="price">{item.price}</span>
                    <span className="shop-now">Shop now</span>
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>

      <div className="slider-nav">
        {Array.from({ length: collections.length - (isMobile ? 0 : 2) }).map((_, index) => (
          <div 
            key={index} 
            className={`nav-dot ${index === currentIndex ? 'active' : ''}`}
            onClick={() => setCurrentIndex(index)}
          ></div>
        ))}
      </div>
    </section>
  );
};

export default Collections;
